/**
 * The dashboard's persisted display preferences.
 *
 * Thin app-scoped binding over the shared `DisplayPrefsStore`
 * (`@authe/fe-commons/display`), which owns the vocabulary + storage keys so a
 * choice like the Overview activity view (table vs graph) or live mode persists
 * across reloads and never diverges from how other surfaces name it. Built once
 * as a module singleton; React surfaces read/write it via `useDisplayPref`.
 */
import { createDisplayPrefsStore } from "@authe/fe-commons/display";
import { createScopedStorage } from "@authe/fe-commons/storage";
import { APPLICATION_SLUG } from "@/config";

export const displayPrefs = createDisplayPrefsStore(
  createScopedStorage({ app: APPLICATION_SLUG }),
);
